export const DEFAULT_WHATSAPP_MESSAGE_TEMPLATE = 'Olá, {nome}. Cheguei até aqui pelo site {dominio} e gostaria de falar.'

const WHATSAPP_HOSTS = new Set(['wa.me', 'api.whatsapp.com', 'web.whatsapp.com'])

export type WhatsappUrlInput = {
  baseUrl: string
  messageTemplate: string
  displayName: string
  canonicalDomain: string
  serviceName?: string
}

export function formatWhatsappMessage(input: Omit<WhatsappUrlInput, 'baseUrl'>): string {
  const template = input.messageTemplate.trim() || DEFAULT_WHATSAPP_MESSAGE_TEMPLATE
  const message = template
    .replace(/\{nome\}/gi, input.displayName.trim())
    .replace(/\{dominio\}/gi, input.canonicalDomain.trim())

  return input.serviceName?.trim()
    ? `${message.trim()}\nGostaria de consultar o serviço “${input.serviceName.trim()}”.`
    : message.trim()
}

export function buildWhatsappUrl(input: WhatsappUrlInput): string {
  try {
    const url = new URL(input.baseUrl)
    if (!WHATSAPP_HOSTS.has(url.hostname.toLowerCase())) return input.baseUrl

    url.searchParams.set('text', formatWhatsappMessage(input))
    return url.toString()
  } catch {
    return input.baseUrl
  }
}
